// src/pages/Accounting/Reconcile/constants.ts

import type { AccountKind } from "./types";

export const PALETTE = {
  ink: "#0E1A1A",
  ink2: "#263238",
  ink3: "#3A4A52",
  ink4: "#6B7684",
  line: "#D8DEE6",
  lineSoft: "#E7EAF0",
  panel: "#F7F8FA",
  bgFade: "#F3F5F5",
  bg: "#FBFBFB",
  tealDark: "#0F6E56",
  teal: "#15A08C",
  brandBg: "#E1F5EE",
  amber: "#F59E0B",
  amberInk: "#92400E",
  red: "#B42318",
  redBg: "#FEF3F2",
  redDark: "#8B1538",
  velaDeep: "#4C1D95",
  vela: "#6B46C1",
  velaLight: "#8B5CF6",
  velaWash: "#EDE9FE",
  velaFade: "#F5F3FF",
} as const;

export const ACCOUNT_KIND_LABELS: Record<AccountKind, string> = {
  checking: "Chequing",
  savings: "Savings",
  "credit-card": "Credit card",
  "line-of-credit": "Line of credit",
  "other-current-asset": "Other current assets",
  "other-current-liability": "Other current liabilities",
  "fixed-asset": "Fixed assets",
  "long-term-liability": "Long-term liabilities",
  equity: "Equity",
} as const;

export const ACCOUNT_KIND_GROUP_LABELS: Record<AccountKind, string> = {
  checking: "Bank",
  savings: "Bank",
  "credit-card": "Credit card",
  "line-of-credit": "Credit card",
  "other-current-asset": "Other current assets",
  "other-current-liability": "Other current liabilities",
  "fixed-asset": "Fixed assets",
  "long-term-liability": "Long-term liabilities",
  equity: "Equity",
} as const;

export const ACCOUNT_KIND_GROUP_ORDER: AccountKind[] = [
  "checking",
  "savings",
  "credit-card",
  "line-of-credit",
  "other-current-asset",
  "fixed-asset",
  "other-current-liability",
  "long-term-liability",
  "equity",
];

export const BANK_LIKE_KINDS: ReadonlySet<AccountKind> = new Set<AccountKind>([
  "checking",
  "savings",
  "credit-card",
  "line-of-credit",
]);